module.exports = __webpack_public_path__ + "img/70.8a90a4b7.jpg";